import React from 'react';

export function InputCheckboxInfo({name, checked, disabled, onChange, title}) {

  return <div className="check-input">
    <input type="checkbox"
           name={name}
           checked={checked}
           disabled={disabled}
           style={{transform: 'scale(2.0)'}}
           onChange={(e) => onChange(name, e.target.checked)} /> <legend>{title}</legend>
  </div>;
}
